module.exports = __webpack_public_path__ + "images/nest-47860e4bd9be2036bf18bbacbb768253.jpg";